export default __webpack_public_path__ + "static/media/dino.fbe86992.svg";